import { ColorMode} from '@chakra-ui/react';

export default function colorModeValue<TLight = unknown, TDark = unknown>(colorMode: ColorMode, light: TLight, dark: TDark) {
  return colorMode === "dark" ? dark : light
}
